import React from 'react'
import { IMG_CON_URL } from '../utils/constants'

const MovieCard = ({posterPath}) => {
  if(!posterPath) return null
  return (
    <div className='w-36 md:w-48 pr-4'>
      <img alt='Movie Card' src={IMG_CON_URL + posterPath} />
    </div>
  )
}

export default MovieCard